import { render, staticRenderFns } from "./Bug.vue?vue&type=template&id=41b378c0&scoped=true"
import script from "./Bug.vue?vue&type=script&lang=js"
export * from "./Bug.vue?vue&type=script&lang=js"
import style0 from "./Bug.vue?vue&type=style&index=0&id=41b378c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b378c0",
  null
  
)

export default component.exports